import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Icon } from '../../atoms/Icon'
import { ModalProps } from './Modal.types'
import { ModalOverlay, ModalContent, CloseButton } from './Modal.styles'

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  width,
  maxWidth,
  closeOnOverlayClick = true,
  showCloseButton = true,
  fullScreen = false,
  className,
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEsc)
    }

    return () => {
      document.removeEventListener('keydown', handleEsc)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const modalContent = (
    <ModalOverlay
      $isOpen={isOpen}
      onClick={closeOnOverlayClick ? onClose : undefined}
    >
      <ModalContent
        $width={width}
        $maxWidth={maxWidth}
        $fullScreen={fullScreen}
        $isOpen={isOpen}
        className={className}
        onClick={(e) => e.stopPropagation()}
      >
        {showCloseButton && (
          <CloseButton onClick={onClose}>
            <Icon name="close" size="medium" />
          </CloseButton>
        )}
        {children}
      </ModalContent>
    </ModalOverlay>
  )

  return createPortal(modalContent, document.body)
}
